import React from 'react'
import { connect } from 'react-redux'
import { nullDate, getListIds, changeListItem } from '../../public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import SetAdjustmentPersonDiv from './SetAdjustmentPersonDiv'
import UseVacationInfoDiv from './UseVacationInfoDiv'
class BatchSpecialLeaveDetail extends React.Component {
    state = {
        changedValues基本信息: {},
    }
    componentDidMount = () => {
        const { id } = this.props
        this.doGetBatchSpecialLeave(id)
    }

    doGetBatchSpecialLeave = (id) => {
        const { taskName } = this.props
        Tyan.doPostEvent({
            event: 'GetBatchSpecialLeave',
            data: {
                id: id || 0,
                taskName
            },
            onEnd: ({ errorMessage, initValues基本信息, initValues用假记录明细, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, initValues用假记录明细, changedValues用假记录明细: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { id, changedValues基本信息, changedValues用假记录明细 } = this.state
        Tyan.doPostEvent({
            event: 'SaveBatchSpecialLeave',
            data: {
                id, changedValues基本信息, changedValues用假记录明细
            },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    this.doGetBatchSpecialLeave(id)
                }
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteBatchSpecialLeave',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    handelSubmit = (action,) => {
        const { onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定执行？', () =>
            Tyan.doPostEvent({
                event: 'SpecialLeaveFlow',
                data: { id, action },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('执行成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    handleSelectChange = (v, fieldName) => {
        const ids = getListIds(this, '用假记录明细', '用假记录明细')
        changeListItem(this, Array(ids.length).fill({ [fieldName]: v }), { [fieldName]: 'string' }, '用假记录明细', '用假记录明细', ids)
    }

    handlerSetPerson = () => {
        const { id } = this.state
        Tyan.pubForm.showDialog('设置人员', props => <SetAdjustmentPersonDiv {...props} id={id} onSave={(id) => this.doGetBatchSpecialLeave(id)} />)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        return true
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    fieldset签核流程 = () => {
        return [
            { _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    fieldset基本信息 = () => {
        return [
            { _text: '记录编号', minWidth: '95%', disabled: true },
            { _date: '创建时间', minWidth: '95%', disabled: true },
            { _text: '记录名称', minWidth: '95%', },
            { _text: '备注', minWidth: '95%', maxRows: 3 },
            { _files: '附件', minWidth: '95%', },
        ]
    }

    fieldset用假记录明细 = () => {
        const { readOnly } = this.props
        const 状态 = getFormValue(this, '基本信息', '状态')
        const ids = getListIds(this, '用假记录明细', '用假记录明细')
        const p = { margin: '5px 15px 5px 15px', minWidth: 150, _full: true, flex: 1 }
        return [].concat([{
            _group: '', padding: '0 10 0 0', minWidth: '90%', items: [
                { _label: '休假人员', ...p, },
                { _label: '开始时间', ...p, cdt: () => (readOnly || 状态 !== '申请中') },
                { _label: '结束时间', ...p, cdt: () => (readOnly || 状态 !== '申请中') },
                { _datetime: '', name: '开始时间', placeholder: '开始时间', ...p, onChange: (v) => this.handleSelectChange(v, '开始时间'), cdt: () => (!readOnly && 状态 == '申请中') },
                { _datetime: '', name: '结束时间', placeholder: '结束时间', ...p, onChange: (v) => this.handleSelectChange(v, '结束时间'), cdt: () => (!readOnly && 状态 == '申请中') },
                { _label: '职务代理人', ...p, },
            ]
        }]).concat([{
            _group: '', margin: '0', items: ids.map(id => ({
                _group: '', padding: '0 10 0 0', list: { listName: '用假记录明细', id }, minWidth: '90%', items: [
                    { _text: '', name: '休假人员', disabled: true, ...p, },
                    { _datetime: '', name: '开始时间', ...p, },
                    { _datetime: '', name: '结束时间', ...p, },
                    { _select: '', name: '职务代理人', optionName: id, ...p, },
                ]
            }))
        }])
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息, } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 提交时间 } = initValues基本信息
        return <Body data={this}
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose }
                ] : [
                    { _button: '提交', icon: 'share', handler: () => this.handelSubmit(`${状态}.提交`), cdt: () => id > 0 && 状态 == '申请中' || 状态 == '签核中', disabled: this.bChanged(), },
                    { _flow: 'UseVacationApplyFlow', disabled: this.bChanged(), cdt: () => id > 0 },
                    { _button: '设置人员...', icon: 'share', handler: () => this.handlerSetPerson(), disabled: this.bChanged(), cdt: () => 状态 == '申请中' },
                    { _button: '保存', icon: 'save', handler: () => this.handlerSave(), disabled: !(this.bSave() && this.bChanged()), cdt: () => 状态 == '申请中' },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 && 状态 == '申请中' && 提交时间 == nullDate, disabled: this.bChanged(), },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    {
                        _fieldsets: [
                            { title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
                            { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                        ], docked: 'right', width: '40%',
                    },
                    { title: '用假记录明细', name: '用假记录明细', _fieldset: this.fieldset用假记录明细(), docked: 'bottom', height: '55%', disabled: readOnly || 状态 !== '申请中' },
                    { title: '批量特休假申请', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || 状态 !== '申请中' },

                ]
            }
        />
    }
}

export default connect()(BatchSpecialLeaveDetail)